// return the translation which match exact locale, default otherwise
const getValidTranslation = (languageTag, fieldDataTranslations) => {
    let traslationToUse;
    fieldDataTranslations.forEach((translation) => {
        if (translation.languageTag === languageTag) {
            traslationToUse = translation;
        }
        else if (translation.default && !traslationToUse) {
            // setting the fallback
            traslationToUse = translation;
        }
    });
    return traslationToUse;
};
const resolveFieldData = (textToResolve, fieldToResolve, textToReplaceWith) => {
    // return the default data if no valid transalation was found
    if (!textToReplaceWith)
        return textToResolve;
    let resolvedText = textToResolve;
    const regexp = new RegExp(`\\b${fieldToResolve}\\b`, 'gi');
    resolvedText = textToResolve.replace(regexp, textToReplaceWith);
    return resolvedText;
};
function getResolvedSMSText(smsRawText, product, languageTag) {
    let resolvedsmsText = smsRawText;
    // resolve each field one by one
    const traslationToUse = getValidTranslation(languageTag, product.nameTranslations);
    resolvedsmsText = resolveFieldData(smsRawText, 'PRODUCT_NAME', traslationToUse?.translation);
    return resolvedsmsText;
}

export { getResolvedSMSText, getValidTranslation };
//# sourceMappingURL=helpers.js.map
